<nav>
    <div class="nav border-bottom-0 nav-tabs mb-3" id="nav-tab" role="tablist">
        <button class="nav-link pt-0 w-130" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-home"
            type="button" role="tab" aria-controls="nav-profile" aria-selected="true">
            VALIDATION CRITERIA
        </button>
    </div>
</nav>
<div class="tab-content  p-0 " id="nav-tabContent">
    <div class="tab-pane fade " id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
        <div class="main mx-0 pb-1">
        </div>
    </div>
    <div class="tab-pane fade active show" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
        <div class="table-responsive tableFixHead_1" [ngClass]="{ 'criteriaDiv': !isFullScreen }">
            <table class="table datatable border-x-0 mb-0">
                <thead>
                    <tr class="subheaderrr">
                        <th width="45%">CRITERIA</th>
                        <th width="40%">ISO RESPONSE</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let item of projectValidationCriteriasAndValidationResponse; let i = index">
                        <tr>
                            <td class="text-start align-middle">{{ item.criteriaText }}</td>
                            <td class="align-middle">
                                <!-- Show textbox for 'Free Text' -->
                                <ng-container *ngIf="item.responseType === 'Free Text'">
                                    <input type="text" class="form-control" placeholder="Enter response"
                                        [disabled]="projectStatus === 'Verified'"
                                        [(ngModel)]="item.verificationValue" />
                                </ng-container>

                                <!-- Show dropdown for 'Dropdown' -->
                                <ng-container *ngIf="item.responseType === 'Dropdown'">
                                    <select class="form-select" [disabled]="projectStatus === 'Verified'"
                                        [(ngModel)]="item.verificationValue">
                                        <option [ngValue]="null" disabled>Select Response</option>
                                        <option *ngFor="let option of item.lstProjectValidationCriteriaResponse"
                                            [ngValue]="option.responseValue">
                                            {{ option.responseValue }}
                                        </option>
                                    </select>
                                </ng-container>

                                <!-- Show multiselect for 'MultiSelect' -->  
                                <ng-container *ngIf="item.responseType === 'MultiSelect'">
                                    <div id="divCarouselView" [ngClass]="{ 'fullscreen-mode': isFullScreen }">
                                        <div [id]="'criteriaContainer_' + i" class="criteria-container">
                                            <p-multiSelect 
                                                [appendTo]="isFullScreen ? '#criteriaContainer_' + i : 'body'"
                                                [options]="item.lstProjectValidationCriteriaResponse" [(ngModel)]="item.multiVerificationValue"
                                                [disabled]="projectStatus === 'Verified'" optionLabel="responseValue" [optionValue]="'responseValue'"
                                                placeholder="Select Response" [showHeader]="true" [filter]="true" (click)="stopPropagation($event)">
                                
                                                <ng-template pTemplate="header">
                                                    <div class="custom-multiselect-header">
                                                        <span style="padding-right: 5px;">SELECT ALL</span>
                                                    </div>
                                                </ng-template>
                                            </p-multiSelect>
                                        </div>
                                    </div>
                                </ng-container>

                                <!-- Show radio buttons for 'Yes/No' -->
                                <ng-container *ngIf="item.responseType === 'Yes/No'">
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio"
                                            name="response_{{ item.projectValidationCriteriaID }}"
                                            id="yes_{{ item.projectValidationCriteriaID }}" value="Yes"
                                            [disabled]="projectStatus === 'Verified'"
                                            [(ngModel)]="item.verificationValue" />
                                        <label class="form-check-label"
                                            for="yes_{{ item.projectValidationCriteriaID }}">Yes</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio"
                                            name="response_{{ item.projectValidationCriteriaID }}"
                                            id="no_{{ item.projectValidationCriteriaID }}" value="No"
                                            [disabled]="projectStatus === 'Verified'"
                                            [(ngModel)]="item.verificationValue" />
                                        <label class="form-check-label"
                                            for="no_{{ item.projectValidationCriteriaID }}">No</label>
                                    </div>
                                </ng-container>

                                <!-- Show checkbox for 'Simple Check' -->
                                <ng-container *ngIf="item.responseType === 'Simple Check'">
                                    <input type="checkbox" [attr.id]="'check_' + item.projectValidationCriteriaID"
                                        [checked]="item.verificationValue === 'Checked'"
                                        [disabled]="projectStatus === 'Verified'"
                                        (change)="onCheckboxChange($event, item)" />
                                    <label [attr.for]="'check_' + item.projectValidationCriteriaID"></label>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-container>
                    <tr>
                        <td colspan="12">
                            {{displayText}}
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
        <div class="mt-4" *ngIf="projectValidationCriterias && projectValidationCriterias.length > 0">
            <div class="d-flex justify-content-end">
                <div>
                    <button class="btn progressBtn ps-2 me-2" role="button" (click)="saveValidationResponses()"
                        [disabled]="projectStatus == 'Verified'" [ngStyle]="{'pointer-events' :   (projectStatus == 'Verified') || (isSaveButtonEnabled) ? 'none':'auto',
                    'opacity' :   (projectStatus == 'Verified') || (isSaveButtonEnabled) ? '0.5':'1' }">
                        <div class="d-flex">
                            <div>
                                <img src="assets/images/green_tickmark.svg" class="btnrefreshIcon" alt="">
                            </div>
                            <div>
                                SAVE RESPONSES
                            </div>
                        </div>
                    </button>

                    <button class="btn progressBtn ps-2" role="button" (click)="removeResponses()"
                        [disabled]="projectStatus == 'Verified' || !isProjectValidationResponseExists" [ngStyle]="{'pointer-events' :   (projectStatus == 'Verified') || (!isProjectValidationResponseExists) ? 'none':'auto',
                    'opacity' :   (projectStatus == 'Verified') || (!isProjectValidationResponseExists) ? '0.5':'1' }">
                        <div class="d-flex">
                            <div>
                                <img src="assets/images/close_mark.svg" class="btnrefreshIcon" alt="">
                            </div>
                            <div>
                                CLEAR RESPONSES
                            </div>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>